export enum CurrencyEnum {
  USD = 'USD' ,
  RUB = 'RUB'
}

export enum CurrencySymbol {
  USD = '$' ,
  RUB = '₽'
}
